import { Button, Info } from '../../../../modules/design-system';
import { QUOTA_FULL_TITLE, quotaFullMessage } from '../../../../modules/shipping';
import type { ShippingQuota } from '../../../../modules/api';

export interface QuotaFullNoticeProps {
  quota: ShippingQuota;
  /** Back to My Packs — the only useful action while the queue is full. */
  onBack: () => void;
}

/**
 * Shown in place of the delivery form when the player already has the
 * operator's maximum number of cards awaiting fulfilment. Informational, not a
 * failure: nothing went wrong, there is simply no room until the pending
 * deliveries ship. All colours via `--co-QuotaFullNotice-*` with hex
 * fallbacks.
 */
export function QuotaFullNotice({ quota, onBack }: QuotaFullNoticeProps) {
  return (
    <div
      data-co-component="QuotaFullNotice"
      role="status"
      className="flex flex-col items-center gap-4 rounded-[16px] border px-4 py-8 text-center"
      style={{
        background: 'var(--co-QuotaFullNotice-fill, rgba(255,255,255,0.04))',
        borderColor: 'var(--co-QuotaFullNotice-border, rgba(255,255,255,0.10))',
      }}
    >
      <span aria-hidden style={{ color: 'var(--co-QuotaFullNotice-iconColor, #7DD3FC)' }}>
        <Info size={28} strokeWidth={1.6} />
      </span>

      <h2
        className="font-bold tracking-[-0.3px]"
        style={{
          color: 'var(--co-QuotaFullNotice-titleColor, #FFFFFF)',
          fontSize: 'var(--co-QuotaFullNotice-titleSize, 18px)',
        }}
      >
        {QUOTA_FULL_TITLE}
      </h2>

      <p
        className="max-w-[420px] text-[13px] leading-[19px]"
        style={{ color: 'var(--co-QuotaFullNotice-textColor, rgba(255,255,255,0.70))' }}
      >
        {quotaFullMessage(quota)}
      </p>

      <Button variant="primary" size="lg" onClick={onBack}>
        Back to My Packs
      </Button>
    </div>
  );
}
